import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import { LazyLoadImage } from '../lazy-load-image';
import styles from './article-card-v2.module.scss';

export interface ArticleCardV2Config {
    dark?: boolean;
    large?: boolean;
    imageFullBleed?: boolean;
}

export interface ArticleCardV2Props extends ArticleCardV2Config {
    article: {
        id: string;
        title: string;
        type: string;
        tag: string;
        image: string;
        url: string;
    };
}

const ArticleCardV2: FC<ArticleCardV2Props> = ({ dark = false, large = false, imageFullBleed = false, article }) => {
    const image = article.image;

    return (
        <Link href={article.url || ''} passHref>
            <a
                className={classNames(styles.root, {
                    [styles.dark]: dark,
                    [styles.large]: large,
                    [styles.imageFullBleed]: imageFullBleed,
                })}
            >
                <div className={styles.zoomedImageContainer}>{image ? <LazyLoadImage className={styles.zoomedImage} imageUrl={image} objectFit="cover" relativeContainer={false} /> : null}</div>
                <div className={styles.main}>
                    <div className={styles.content}>
                        <div className={styles.information}>
                            <div className={styles.category}>{article.tag}</div>
                            <div className={styles.dotDivider}>•</div>
                            <div className={styles.date}>{article.type}</div>
                        </div>

                        <div title={article.title} className={styles.title}>
                            {article.title}
                        </div>
                    </div>
                </div>
            </a>
        </Link>
    );
};

export default ArticleCardV2;
